<div class="filter">
  <h4 class="mat-headline-6">Filters</h4>
  <div class="filter__wrapper">
    <ng-container *ngFor="let filter of model; let last = last">
      <div class="filter__group">
        <label class="filter__group__header">{{ filter.label }}</label>
        <mat-checkbox
          class="filter__group__field"
          color="primary"
          *ngFor="let item of filter.values"
          [checked]="item.selected"
          [data-ga-value]="'filter-checkbox' + item.label"
          (change)="updateFilterSelected(item)"
          >{{ item.label }}
          <span class="code">{{ getCurrencyCode(item) }}</span></mat-checkbox
        >
        <mat-divider *ngIf="!last"></mat-divider>
      </div>
    </ng-container>
  </div>
</div>
